// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/Login.tsx
// ═══════════════════════════════════════════════════════════════

import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">CloudERP</h1>
          <p className="text-gray-500 mt-2">Sign in to your account</p>
        </div>
        <button
          onClick={() => {
            navigate("/");
          }}
          className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
        >
          Sign in with Authmi
        </button>
        <p className="text-xs text-gray-400 text-center mt-4">
          Dev mode: click to auto-login
        </p>
      </div>
    </div>
  );
}
